import MuiDrawer, { type DrawerProps } from "@mui/material/Drawer";
import MuiSwipeableDrawer, {
  type SwipeableDrawerProps,
} from "@mui/material/SwipeableDrawer";

export type { DrawerProps, SwipeableDrawerProps };

export function Drawer({ anchor = "right", hideBackdrop = true, ...props }: DrawerProps) {
  return <MuiDrawer anchor={anchor} hideBackdrop={hideBackdrop} {...props} />;
}

export function SwipeableDrawer(props: SwipeableDrawerProps) {
  return <MuiSwipeableDrawer {...props} />;
}
